import styled from "styled-components";
import * as Color from "../../general/Color";

// TODO: Extract this into a common theme for inputs.

/**
 * A styled version of the text area component.
 */
export const StyledNativeInput = styled.textarea`
  font: inherit;
  color: inherit;
  text-decoration: inherit;
  line-height: inherit;
  grid-area: 1 / 1 / 2 / 2;

  padding: 0.5rem;
  margin: 0;
  width: 100%;
  min-height: ${(props) => (props.rows !== undefined) ? "unset" : "100%" };
  resize: none;
  transition: border-color 0.2s ease;

  background-color: ${Color.toString(Color.White)};
  border: solid 1px ${Color.toString(Color.LightGrey[300])};
  border-radius: 0.25rem;
  display: block;

  &.no-scroll {
    overflow: hidden;
  }

  &::placeholder,
  &:-ms-input-placeholder,
  &::-ms-input-placeholder {
    color: ${Color.toString(Color.LightGrey[400])}
  }

  &:focus,
  &:hover {
    outline: none;
  }

  &.invalid {
    border-color: ${Color.toString(Color.Red[600])};
  }

  &:read-only {
    background-color: ${Color.toString(Color.LightGrey[100])};
    border-color: ${Color.toString(Color.LightGrey[200])};
  }

  &:disabled {
    background-color: ${Color.toString(Color.LightGrey[200])};
    border-color: ${Color.toString(Color.LightGrey[200])};
    color: transparent;

    &::placeholder,
    &:-ms-input-placeholder,
    &::-ms-input-placeholder {
      color: transparent;
    }
  }

  &:not(:disabled) {
    &:not(:read-only) {
      &:focus {
        border-color: ${Color.toString(Color.Turqoise[400])};
      }

      &:hover {
        border-color: ${Color.toString(Color.LightGrey[700])};
      }
    }
  }
`;
